import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpHandler,
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../providers';

@Injectable({
  providedIn: 'root',
})
export class MetricsApiService {
  constructor(
    protected http: HttpClient,
    protected authenticationService: AuthenticationService
  ) {}

  get<Payload>(endpoint: string = ''): Observable<Payload> {
    const headers = this.getHeaders();
    const url = `${environment.metricsApiUrl}/${endpoint}`;
    return this.http.get<Payload>(url, { headers });
  }

  protected getHeaders = (): HttpHeaders => {
    const clientId = this.authenticationService.getClientId();
    const accessToken = this.authenticationService.tokenInfo.AccessToken;
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${accessToken}`
    );
    if (clientId != null) {
      headers = headers.append('ClientId', clientId.toString());
    }
    return headers;
  };
}
